import { Box, Flex, Heading, Image, Text } from "@chakra-ui/react";
import React from "react";
import ButtonTheme from "./ButtonTheme";
import { formatNumberWithCommas } from '../utils';
import {API_BASE_IMAGES} from "../OldApp";

const PropertyBox = ({property, visitProperty, is_available}) => {

  return (
    <>
    {property && (is_available === property.available) &&  (<Flex
      className={"property-box " + (!property.available ? " grayedout" : "active")}
      borderRadius={"30px"}
      background={"white"}
      boxShadow={"0px 4px 30px 0px rgba(0, 0, 0, 0.25)"}
      overflow={"hidden"}
      mb={6}
      h={{ xl:"174px",md: "144px", base: "300px" }}
      flexDir={{ base: "column", md: "row" }}
    >
      <Image
      filter={!property.available ? "grayscale(1)" : ""}
        w={{ md: "200px", base: "100%" }}
        h={{ xl:"174px",md: "144px", base: "150px" }}
        objectFit={"cover"}
        src={API_BASE_IMAGES + property?.photos?.[0]?.path_300}
      />
      <Box p={{ xl: 4, base: 2 }} flexGrow={1}>
        <Heading
        noOfLines={1}
          mb={1}
          fontSize={{ xl: "2xl", sm: "xl", base: "md" }}
          color={"DarkBlue"}
        >
          {property.externalName}
        </Heading>
        <Text
          mb={{ xl: 2, base: 1 }}
          fontSize={{ sm: "md", base: "sm" }}
          color={"DarkBlue"}
          noOfLines={1}
        >
          {property.city && property.city.name ? property.city.name : property.city}, {property.state} {property?.zip || property?.zip_code}
        </Text>
       {property && property.available && (<Text fontSize={{ sm: "md", base: "sm" }} color={"Teal"}>
          {formatNumberWithCommas(property?.space_available)} Sq. Ft. Available
        </Text>)}
        <Box textAlign={"right"} >
          <ButtonTheme
          handleButtonClick = {() => visitProperty(property)}
            btnText={"Visit Property"}
            chakraProps={{
              fontSize: { lg: "md", base: "xs" },
              h: { lg: "48px", base: "40px" },
              w: "auto",
            }}
          />
        </Box>
      </Box>
    </Flex>)}</>
  );
};

export default PropertyBox;
